<ng-container *ngIf="!loading">

  <div id="game" class="bg-bluesky game" [class.game-mobile]="!deviceSrv.isDesktop()">
    <div class="container-fluid container-md">
      <div class="text-right bg-white pt-4 pr-4 rounded-top">
        <i class="fa-solid fa-xmark text-primary pointer icon-lg cross-icon" (click)="close()"></i>
      </div>

      <div class="game-content pb-4 rounded-bottom">
        <div class="game-content-container text-primary">
          <h1 class="text-center mb-4" *ngIf="level">{{level.name}}</h1>
          <p translate>Le moment est venu de tester tes progrès !</p>
          <p translate>Comme lors du TOEIC, l’examen blanc et entièrement en anglais. Il durera 2h, avec 45 minute dédié aux questions de compréhension oral et 75 minutes pour les questions de compréhension écrite.</p>
          <p translate>A chaque début de partie, les consignes seront énoncer à l’oral et à l’écrit.</p>
          <p translate>Pour la partie Listening, 20 seconde de silence sont laissé entre chaque question pour répondre. A la fin de la piste audio, un temps de 30 seconde est laisser pour répondre et revérifier ses réponses, avant le passage automatique à la partie suivante.</p>
          <p translate>Penses à mettre en pratique les conseils spécial TOEIC donné tout au long de ton apprentissage.</p>
          <button class="btn btn-primary btn-block btn-lg bolder mt-4" (click)="startExam()">C'est parti !</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

